var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// libs
import React, { memo } from 'react';
// HOC
import withIconDefaults from './withIconDefaults';
function IconPencil(_a) {
    var { fillColor } = _a, props = __rest(_a, ["fillColor"]);
    return (React.createElement("svg", Object.assign({ viewBox: "0 0 20 20", fill: "none" }, props),
        React.createElement("path", { d: "M3.375 14.6251H4.2L12.5063 6.31885L11.6813 5.49385L3.375 13.8001V14.6251ZM14.8875 5.5126L12.4875 3.1126L13.275 2.3251C13.4875 2.1126 13.75 2.00635 14.0625 2.00635C14.375 2.00635 14.6375 2.1126 14.85 2.3251L15.675 3.1501C15.8875 3.3626 15.9938 3.6251 15.9938 3.9376C15.9938 4.2501 15.8875 4.5126 15.675 4.7251L14.8875 5.5126ZM14.1 6.3001L4.65 15.7501H2.25V13.3501L11.7 3.9001L14.1 6.3001ZM12.0938 5.90635L11.6813 5.49385L12.5063 6.31885L12.0938 5.90635Z", fill: fillColor })));
}
export default memo(withIconDefaults(IconPencil));
